<script>
import { layoutComputed, authComputed } from '@/state/helpers'
import AdminLayout from './admin-layout/index'
import UserLayout from './user-layout/index'
import LoadingLayout from './shared/loading'
export default {
  data () {
    return {}
  },
  computed: {
    ...layoutComputed,
    ...authComputed,
    layout () {
      if (this.userRole === 'admin') return AdminLayout
      if (this.userRole === 'user') return UserLayout
      return LoadingLayout
    }
  },
  methods: {},
  mounted () {
    this.$store.dispatch('cart/getCart')
  }
}
</script>

<template>
  <component :is="layout" :layout="layoutType">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </component>
</template>
